import React, { useEffect } from 'react'

type Props = {
  isQb?: boolean
}

const OAuthSuccess: React.FC<Props> = ({ isQb = false }) => {
  useEffect(() => {
    const opener = window.opener as Window | undefined

    if (isQb && opener?.checkQbConnectivity) {
      opener.checkQbConnectivity()
      window.close()
    }

    if (opener?.checkConnectivity) {
      opener.checkConnectivity()
      window.close()
    }

    window.location.href = '/app'
  }, [isQb])

  return <div>Successfully authorized!</div>
}

export default OAuthSuccess
